<template>
  <div>
    <div v-if="$auth.policies['view-period-list']" class="pa-4">
      <div class="px-4 mb-6 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="`Chi tiết kỳ đóng ${$options.filters.convertFullDate(detailPeriod.title)}`"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: 'Kỳ thu/đóng', href: '#' },
              { text: `Chi tiết kỳ đóng ${$options.filters.convertFullDate(detailPeriod.title)}` }
            ]"
          />
        </div>

        <div>
          <div class="d-flex justify-end align-start">
            <ExportExcel />
            <div v-if="isSummaryButtonShown">
              <v-btn v-if="$auth.policies['summary-period']" class="search-button ml-6" @click="openDialog" outlined>
                <v-icon>mdi-wallet-plus</v-icon> &nbsp; Tổng kết lại
              </v-btn>
            </div>
            <FreezeSection v-if="isFreezeSectionShown" class="ml-6" />
          </div>
          <div class="d-flex justify-end mt-4" v-if="!isFrozen">
            <v-btn
              v-if="$auth.policies['upload-excel-reconciliation']"
              class="mr-6 pa-5"
              dark
              color="#0D47A1"
              @click="openDialogVerify"
            >
              <v-icon left>mdi-file-download-outline</v-icon>
              Nhập Excel đối soát
            </v-btn>
            <v-btn
              v-if="$auth.policies['upload-excel-refund']"
              class="pa-5"
              dark
              color="#0D47A1"
              @click="openDialogRefund"
            >
              <v-icon left>mdi-file-download-outline</v-icon>
              Nhập Excel hoàn trả
            </v-btn>
          </div>
        </div>
      </div>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <DetailInfoPeriod />
      </v-card>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <StudentTable />
      </v-card>
      <ReSummary ref="reSummary"></ReSummary>
    </div>
    <div v-else>
      <Page403 />
    </div>
    <PopupVerifyExcel ref="popup-verify" />
    <DialogRefund ref="popup-refund" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import DetailInfoPeriod from '@/modules/tuitionFee/detail-period/DetailInfoPeriod'
import StudentTable from '@/modules/tuitionFee/detail-period/StudentTable'
import { mapActions, mapGetters } from 'vuex'
import ReSummary from '../../modules/tuitionFee/detail-period/ReSummary.vue'
import Page403 from '@/views/Page403.vue'
import ExportExcel from '@/modules/tuitionFee/detail-period/action/ExportExcel.vue'
import PopupVerifyExcel from '../../modules/tuitionFee/detail-period/PopupVerifyExcel.vue'
import DialogRefund from '../../modules/tuitionFee/detail-period/action/DialogRefund.vue'
import FreezeSection from '../../modules/tuitionFee/detail-period/action/FreezeSection.vue'
import { get } from 'lodash'
import moment from 'moment'

export default {
  components: {
    Breadcrumbs,
    DetailInfoPeriod,
    StudentTable,
    ReSummary,
    ExportExcel,
    PopupVerifyExcel,
    DialogRefund,
    Page403,
    FreezeSection
  },
  async created() {
    await this.fetchPeriod(this.$route.params.id)
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      role: 'auth/role'
    }),
    isAdmin() {
      return get(this.role, 'type') === 'manager'
    },
    isFrozen() {
      return get(this.detailPeriod, 'isFrozen', false)
    },
    isSummaryButtonShown() {
      return this.detailPeriod.status === 'finished' && !this.isFrozen
    },
    isFreezeSectionShown() {
      return this.detailPeriod.status === 'finished'
    }
  },
  methods: {
    ...mapActions('tuitionFeePeriod', ['fetchPeriod']),
    openDialog() {
      this.$refs.reSummary.openDialog()
    },
    openDialogVerify() {
      this.$refs['popup-verify'].openDialog()
    },
    openDialogRefund() {
      this.$refs['popup-refund'].openDialog()
    }
  }
}
</script>
